import { render, staticRenderFns } from "./GlobalDispatchFooter.vue?vue&type=template&id=1db1ad66&scoped=true&name=global-dispatch-footer&"
import script from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
export * from "./GlobalDispatchFooter.vue?vue&type=script&lang=js&"
import style0 from "./GlobalDispatchFooter.vue?vue&type=style&index=0&id=1db1ad66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db1ad66",
  null
  
)

export default component.exports